import axios from 'axios'
import environment from '@/configs/environtment'
import setup from './setupInterceptorV2'

const API_URL = environment.getApiOpenBaseUrl()
// const API_URL = 'https://dummyjson.com'
const apiOpenPdf = axios.create({
  baseURL: API_URL,
  withCredentials: false,
  headers: {
    'Content-Type': 'application/json; charset=utf-8',
    Accept: '*/*',
  },
  responseType: 'blob'
})

apiOpenPdf.interceptors.request.use((config: any) => config, (error: any) => Promise.reject(error))

setup(apiOpenPdf)

export default apiOpenPdf
